const stdTimezoneOffset = (date) => {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

const isDaylightSavingTime = (date) => {
    return date.getTimezoneOffset() < stdTimezoneOffset(date);
};

const getHourInNordics = (date) => {
    const isFinland = window.iimclient && window.iimclient.brandingClass === 'finland';
    const hour = date.getUTCHours();
    return hour + (isDaylightSavingTime(date) ? 2 : 1) + (isFinland ? 1 : 0);
};

const isOutsideOpeningHours = (date) => {
    const day = date.getUTCDay();
    const hour = getHourInNordics(date);
    const minute = date.getUTCMinutes();
    const hourMinute = hour * 100 + minute;

    return (
        hourMinute < 800 ||
        hourMinute >= 1930 ||
        (day === 5 && hourMinute >= 1730) || // Friday
        (day === 6 && (hourMinute < 900 || hourMinute >= 1630)) || // Saturday
        day === 0 // Sunday
    );
};

export { isDaylightSavingTime, getHourInNordics, isOutsideOpeningHours };
